import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import './skeleton.scss';

export const Skeleton = ({ className = '', style = undefined }) => {
  return <span className={classnames('skeleton', className)} style={style} />;
};

Skeleton.propTypes = {
  className: PropTypes.string,
  style: PropTypes.shape({}),
};
